module.exports = __webpack_public_path__ + "static/media/consumer_background.364f9f58.png";